export const LogoIcon = () => (
  <svg height="32" viewBox="0 0 44 46" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="eLgI" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#4DD8E8" />
        <stop offset="50%" stopColor="#6B40E0" />
        <stop offset="100%" stopColor="#3A0FBB" />
      </linearGradient>
    </defs>

    {/* Ring 1 */}
    <ellipse cx="22" cy="11" rx="16" ry="6.5"
      fill="none" stroke="url(#eLgI)" strokeWidth="4.2" strokeLinecap="round"
      strokeDasharray="52 20" />
    <ellipse cx="22" cy="11" rx="16" ry="6.5"
      fill="none" stroke="url(#eLgI)" strokeWidth="4.2" strokeLinecap="round"
      strokeDasharray="20 52" strokeDashoffset="-52" opacity="0.35" />

    {/* Ring 2 */}
    <ellipse cx="22" cy="23" rx="16" ry="6.5"
      fill="none" stroke="url(#eLgI)" strokeWidth="4.2" strokeLinecap="round"
      strokeDasharray="52 20" />
    <ellipse cx="22" cy="23" rx="16" ry="6.5"
      fill="none" stroke="url(#eLgI)" strokeWidth="4.2" strokeLinecap="round"
      strokeDasharray="20 52" strokeDashoffset="-52" opacity="0.35" />

    {/* Ring 3 */}
    <ellipse cx="22" cy="35" rx="16" ry="6.5"
      fill="none" stroke="url(#eLgI)" strokeWidth="4.2" strokeLinecap="round"
      strokeDasharray="52 20" />
    <ellipse cx="22" cy="35" rx="16" ry="6.5"
      fill="none" stroke="url(#eLgI)" strokeWidth="4.2" strokeLinecap="round"
      strokeDasharray="20 52" strokeDashoffset="-52" opacity="0.35" />
  </svg>
);
